<template lang="pug">
#PageResultProfile
    //- Header Global
    .change-on-mobile
        button.mobile-only.overlay-button(
            v-on:click="toggleSidebar()"
        )
            .btn-change-menu
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-chevron-left"><polyline points="15 18 9 12 15 6"></polyline></svg>
        HeaderGlobal(HeaderGlobalHeading="Profile" :HeaderGlobalBreadcrumb="breadcrumb")

    //- personal info
    PersonalInfo

    //- Family info
    FamilyInfo

    //- Vehiclel info
    //- VehicleInfo

</template>

<script>
import HeaderGlobal from './../../components/HeaderGlobal.vue'
import PersonalInfo from './../../pages/result/profile/Personal.vue'
import FamilyInfo from './../../pages/result/profile/Family.vue'
// import VehicleInfo from './../../pages/result/profile/Vehicle.vue'

export default {
    name: 'Profile',
    components: {
        HeaderGlobal,
        PersonalInfo,
        FamilyInfo,
        // VehicleInfo,
    },
    props: ['resultGlobalBreadcrumb'],
    data: function() {
        return {
            breadcrumb: [
                this.resultGlobalBreadcrumb,
                {
                    name: 'Profile',
                    url: '/result/profile',
                },
            ],
        };
    },
    mounted: function() {
        // 
    },
    methods: {
        toggleSidebar() {
            EventEmit.$emit('toggleSidebar')
        }
    }
}
</script>

<style lang="sass">
</style>
